import PropTypes from "prop-types";
import React, { useContext } from "react";

import { withTheme } from "@material-ui/core";

import API from "../../../../API";
import { withSnackbar } from "../../../../HOC/withSnackbar";
import Typography from "../../../../components/Helpers/Typography";
import { FleetContext } from "../../../../context";
import { useDialog } from "../../../../hooks/useDialog";
import { vehicleType } from "../../../../services/types.service";

export const StartRideButton = ({ vehicle, theme, setSnackbarMessage }) => {
  const { setActiveVehicle } = useContext(FleetContext);
  const reserved = vehicle.target_state === "reserved";
  const available = vehicle.target_state === "available";

  const disableButton = !(reserved || available);
  const startTrip = async () => {
    const oldStatus = vehicle.target_state;
    setActiveVehicle({
      ...vehicle,
      target_state: "reserved",
    });
    try {
      const data = await API.vehicle.startTrip(vehicle.id);
      setActiveVehicle({
        ...vehicle,
        ...data,
      });
    } catch (e) {
      setSnackbarMessage(e.message);

      setActiveVehicle({
        ...vehicle,
        target_state: oldStatus,
      });
    }
  };

  const endTrip = async () => {
    setActiveVehicle({
      ...vehicle,
      target_state: "available",
    });
    try {
      const data = await API.vehicle.endTrip(vehicle.id);
      setActiveVehicle({
        ...vehicle,
        ...data,
      });
    } catch (e) {
      setSnackbarMessage(e.message);
      setActiveVehicle({
        ...vehicle,
        target_state: "reserved",
      });
    }
  };

  const [openDialog, dialog] = useDialog({
    title: "End active trip",
    body: "You are trying to end an active trip. Do you want to proceed?",
  });

  const onClick = reserved ? () => openDialog(() => endTrip) : startTrip;

  return (
    <button
      type="button"
      id="start-trip-button"
      style={{
        textTransform: "uppercase",
        width: "calc(100% - 32px)",
        padding: 10,
        position: "absolute",
        bottom: 20,
        left: 16,
        background: theme.palette.background.dark,
        borderStyle: "none",
        cursor: disableButton ? "not-allowed" : "pointer",
        display: "block",
        height: "auto",
        opacity: disableButton && "30%",
      }}
      onClick={onClick}
      disabled={disableButton}
    >
      <Typography variant="button">{reserved ? "end trip" : "start trip"}</Typography>

      {disableButton && (
        <span
          style={{
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            background: theme.palette.background.disabled,
            height: "100%",
            width: "100%",
          }}
        />
      )}

      {dialog}
    </button>
  );
};

StartRideButton.propTypes = {
  vehicle: vehicleType.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withTheme(withSnackbar(StartRideButton));
